import urls from '../constants/urls';

export const LOAD_APIS_FAILED = 'api/LOAD_APIS_FAILED';
export const LOAD_APIS_SUCCESS = 'api/LOAD_APIS_SUCCESS';
export const LOADING_APIS = 'api/LOADING_APIS';

const initialState = {
  sites: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_APIS:
      return {
        ...state,
        isLoading: true,
        failedLoading: false,
      };

    case LOAD_APIS_SUCCESS:
      return {
        ...state,
        sites: action.payload.data.data,
        isLoading: false,
      };

    case LOAD_APIS_FAILED:
      return {
        ...state,
        isLoading: false,
        failedLoading: true,
      };

    default:
      return state;
  }
};

export const loadApis = (opts = {}) => dispatch => {
  return dispatch({
    types: [LOADING_APIS, LOAD_APIS_SUCCESS, LOAD_APIS_FAILED],
    payload: {
      request: {
        url: urls.directoryUrl,
        newsFeedUrl: urls.newsFeedUrl,
      },
    },
  });
};
